var render, staticRenderFns
import script from "./DefinitionListSkeleton.vue?vue&type=script&lang=ts&"
export * from "./DefinitionListSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./DefinitionListSkeleton.vue?vue&type=style&index=0&id=896cb7fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports